<template>
  <b-card
    title="Boucle Interne"
    v-if="form">
    <b-form-group label="Taille de lot:" label-for="exampleBatch" style="width: 100%">
      <b-form-input
        id="exampleBatch"
        type="number"
        v-model="form.batch_size"
        required
        step="1"
        placeholder="Entrez la taille de lot"
      />
    </b-form-group>
    <b-form-group label="Nombre de cartes:" label-for="exampleNbCard" style="width: 100%">
      <b-form-input
        id="exampleNbCard"
        type="number"
        v-model="form.nbr_card"
        required
        step="1"
        placeholder="Entrez le nombre de cartes"
      />
    </b-form-group>
    <b-form-group 
        id="destination" 
        label="Destination" 
        label-for="destinationInput">
            <b-form-input 
            placeholder="Entrez la destination (Ex: FA02A)"
            id="destinationInput" 
            type="text"
            v-model="form.destination" 
            step="1"
            required/>
    </b-form-group>
  </b-card>
</template>
<script>
// /!\ CODE CONSTRUCTION FOR EMPLACEMENT = ZONE + POS_Y + POS_X + POS_Z
//                                       =  S   +   Z   +   7   +   A
import { mapGetters } from 'vuex'

export default {
  name: 'InternalForm',
  props: {},
  data() {
    return {
        ranking_choice: ['A', 'B', 'C', 'D', 'E'],
    };
  },
  computed: {
     ...mapGetters({
      form: 'getFormKanban'
    })
  },
  methods: {
  },
  mounted: function () {
    console.log(this.form)
  },
  components: {  }
};
</script>



// WEBPACK FOOTER //
// src/components/kanban/InternalForm.vue